import {Component, Input, OnChanges, OnInit} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import {AlertService, CheckoutGatewayService, MerchantService} from '../_services';
import { CrudPagedListComponent } from '../_directives';
import {Merchant, CRM, Gateway} from '../_models';
import { Observable } from "rxjs";
import {takeUntil} from 'rxjs/operators';

@Component({
  moduleId: module.id.toString(),
  templateUrl: './merchant.component.html',
  selector: 'merchants'
})
export class MerchantComponent extends CrudPagedListComponent implements OnInit, OnChanges {
  merchants$: Observable<Merchant[]> = this.data$;
  gateways: Gateway[] = [];

  @Input('crm') crm: CRM;

  constructor(
    protected router: Router,
    protected location: Location,
    protected route: ActivatedRoute,
    protected merchantService: MerchantService,
    protected alertService: AlertService,
    protected gatewayService: CheckoutGatewayService
  ) {
    super(router, location, route, merchantService, alertService);
    this.objectName = 'merchant';
    this.title = 'CRM Merchant Gateways';
  }

  ngOnInit() {
    this.gatewayService.list()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (gateways: Gateway[]) => {
          this.gateways = gateways;
        },
        error => {
          this.handleError(error);
        }
      );

    this.onInputDataChanged();
  }

  ngOnChanges(): void {
    this.onInputDataChanged();
  }

  protected onInputDataChanged() {
    if (this.crm) {
      this.setFilter({crm: this.crm.id});
    }
  }

  selectGateway(gatewayId, merchant: Merchant) {
    this.loading = true;
    this.merchantService.patch(merchant.id, {solvpath_gateway: gatewayId})
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (newMerchant: Merchant) => {
          this.alertService.success('Selected gateway for ' + merchant.name + '.');
          this.loading = false;
          this.update(newMerchant);
        },
        error => {
          this.handleSubmitError(error);
          this.loading = false;
        });
  }
}
